import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilePdf, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons"

const RenderDocs = ({ docs }) => {
  const listings = docs.listings
  const division = docs.division

  for (var i = 0; i < listings.length; i++) {
    if (listings[i].primary.division === division) {
      var buffer = []
      for (var j = 0; j < listings[i].fields.length; j++) {
        const doc = listings[i].fields[j].division_level_document
        if (doc) {
          let label = doc.name
            ? doc.name.replace(/\.[^/.]+$/, "")
            : doc.url.replace(/\.[^/.]+$/, "")
          if (doc._linkType === "Link.web") {
            label = "LCB Employment Application"
          }
          buffer.push(
            <p>
              <FontAwesomeIcon icon={faFilePdf} className="mr-2 text-danger" />
              <a
                href={listings[i].fields[j].division_level_document.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {label}
              </a>
              <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-2" />
            </p>
          )
        }
      }
      return <div>{buffer}</div>
    }
  }
}

export default ({ props }) => {
  if (!props) return <div>no data</div>
  return <RenderDocs docs={props} />
}
